/**
 * @fileoverview Browser router instance configuration.
 */

import { createBrowserRouter } from 'react-router';
import { rootRoutes } from './rootRoutes';

export const router = createBrowserRouter(rootRoutes);

